import { g as r } from "../../utils-BOfnFgIH.js";
import { I as s } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as l, normalizeClass as d, createElementVNode as e, createStaticVNode as p } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialpadStarMarkColor",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(s).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return s[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], u = ["fill"], _ = ["id"], m = /* @__PURE__ */ p('<stop stop-color="#471571"></stop><stop offset=".031" stop-color="#551B84"></stop><stop offset=".145" stop-color="#7C229E"></stop><stop offset=".237" stop-color="#9024A4"></stop><stop offset=".355" stop-color="#B02290"></stop><stop offset=".483" stop-color="#D32B86"></stop><stop offset=".603" stop-color="#E92F6F"></stop><stop offset=".701" stop-color="#F6484F"></stop><stop offset=".9" stop-color="#FB7328"></stop><stop offset=".973" stop-color="#F3960F"></stop><stop offset="1" stop-color="#F3960F"></stop>', 11), h = [
  m
];
function g(t, S, a, F, I, o) {
  return l(), i("svg", {
    "aria-label": a.ariaLabel,
    class: d([o.iconSizeClass, "d-icon d-icon--dialpad-star-mark-color"]),
    "data-qa": o.dataQA,
    "aria-hidden": o.ariaHidden,
    role: "img",
    "data-name": "Dialpad Star Mark Color",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("path", {
      d: "M20.259 11.193c.218-.102.172-.494-.061-.547-3.49-.802-6.208-3.999-6.791-8.01-.039-.265-.492-.328-.586-.078-1.503 4.791-4.756 8.542-9.084 10.37-.21.103-.168.467.058.523 3.41.848 6.056 3.987 6.648 7.92.04.26.455.318.55.075 1.733-5.014 5.05-8.78 9.266-10.254Z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, u),
    e("defs", null, [
      e("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "3.6",
        y1: "2.4",
        x2: "22.63",
        y2: "19.051",
        gradientUnits: "userSpaceOnUse"
      }, h, 8, _)
    ])
  ], 10, f);
}
const C = /* @__PURE__ */ n(c, [["render", g]]);
export {
  C as default
};
//# sourceMappingURL=dialpad-star-mark-color.js.map
